export const formatTimer = (d: number) => {
  const ms = Math.floor((d % 1000) / 100);
  d /= 1000;
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor((d % 3600) % 60);
  const hours = h > 0 ? h : "";
  let minutes: string | number = m;
  if (h > 0 && m < 10) {
    minutes = `0${minutes}`;
  }
  const seconds = s > 0 ? (s >= 10 ? s : "0" + s) : "00";

  if (h > 0) {
    return `${hours}:${minutes}:${seconds}`;
  }

  return `${minutes}:${seconds}.${ms}`;
};
